/**
 * FUEL IQ DESIGN SYSTEM 2.0
 *
 * Export all design system components for easy import throughout the app.
 */

import themeExport from './theme';

export { designTokens } from './designTokens';
export type { DesignTokens } from './designTokens';
export { theme } from './theme';
export {
  cardVariants,
  buttonVariants,
  chartStyles,
  badgeVariants,
  inputVariants,
  animations,
} from './componentVariants';

// Re-export default theme
export default themeExport;
